import { useTranslation } from 'react-i18next';

import ConfirmModal from '../../../../../styledComponents/ConfirmModal/ConfirmModal';
import {
  Description,
  Name,
} from '../../../Modals/Common/memberOverviewModals.styles';
import { DELETE_AA_FAMILY_MEMBER_MODAL_NAME } from './deleteAAFamilyMemberModal.const';
import { useDeleteAAFamilyMemberModal } from './deleteAAFamilyMemberModal.hooks';

type DeleteAAFamilyMemberModalProps = {
  onFamilyMemberRemoved?: () => void;
  id?: string;
};

const DeleteAAFamilyMemberModal = ({
  onFamilyMemberRemoved,
  id,
}: DeleteAAFamilyMemberModalProps) => {
  const { t } = useTranslation();
  const { onBackHandler, name, isDeleting, deleteSecondaryMemberHandler } =
    useDeleteAAFamilyMemberModal({ onFamilyMemberRemoved, id });
  return (
    <ConfirmModal
      buttons={[
        {
          action: onBackHandler,
          type: 'back',
          styleType: 'light1',
          disabled: isDeleting,
        },
        {
          action: deleteSecondaryMemberHandler,
          type: 'delete',
          styleType: 'background-delete',
          isProcessing: isDeleting,
        },
      ]}
      name={DELETE_AA_FAMILY_MEMBER_MODAL_NAME + id}
      disabled={isDeleting}
      title={t('headers.remove-family-member')}
    >
      <Description>{t('phrase.confirm-remove-family-member')}</Description>
      <Name>{name}</Name>
    </ConfirmModal>
  );
};

export default DeleteAAFamilyMemberModal;
